export const commonEn: Record<string, string> = {
  "Язык": "Language",
  "Русский": "Russian",
  "Английский": "English",
  "Назад": "Back",
  "Закрыть": "Close",
  "ГЛАВНАЯ": "HOME",
  "ПРОЕКТЫ": "PROJECTS",
  "ВОПРОСЫ": "FAQ",
  "Связаться": "Get in touch",
  "Связаться с нами": "Get in touch",
};
